type CargoCompanyOption = {
    id: number;
    name: string;
};

export const mapSellerShipmentCosts = (
    data: any[],
    companyOptions: CargoCompanyOption[] | undefined
) =>
    (data || []).map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        shippingCompanyName: (companyOptions || []).find((x) => x.id === item.shippingCompanyId)?.name || '',
    }));
